import withLessonListItemData from "../lessons/withLessonListItemData";
import LessonListItem from "./LessonListItem";

export default withLessonListItemData(LessonListItem);
